export default "__VITE_ASSET__2894980e__"